var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 19.1686H12.5003C16.667 19.1686 18.3337 17.502 18.3337 13.3353V8.33529C18.3337 4.16862 16.667 2.50195 12.5003 2.50195H7.50033C3.33366 2.50195 1.66699 4.16862 1.66699 8.33529V13.3353C1.66699 17.502 3.33366 19.1686 7.50033 19.1686Z",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22461 16.6266L6.33294 13.8683C6.99128 13.4266 7.94128 13.4766 8.53294 13.985L8.80794 14.2266C9.45794 14.785 10.5079 14.785 11.1579 14.2266L14.6246 11.2516C15.2746 10.6933 16.3246 10.6933 16.9746 11.2516L18.3329 12.4183M7.49961 9.16829C7.94164 9.16829 8.36556 8.9927 8.67812 8.68014C8.99068 8.36758 9.16628 7.94366 9.16628 7.50163C9.16628 7.0596 8.99068 6.63568 8.67812 6.32312C8.36556 6.01056 7.94164 5.83496 7.49961 5.83496C7.05758 5.83496 6.63366 6.01056 6.3211 6.32312C6.00854 6.63568 5.83294 7.0596 5.83294 7.50163C5.83294 7.94366 6.00854 8.36758 6.3211 8.68014C6.63366 8.9927 7.05758 9.16829 7.49961 9.16829Z",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.1c84d21da0b863b60603a64681d723a6.svg";
export { ForwardRef as ReactComponent };